import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(_: Error): State {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("Error Boundary caught:", error, errorInfo);
  }

//   handleRefresh = (): void => {
//     sessionStorage.removeItem("chunk-retry");
//     window.location.reload();
//   };

  render() {
    if (this.state.hasError) {
        return (
        <div style={{ padding: "20px" }}>
            Something went wrong. Please reload the page.
        </div>
        );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;